module.exports = "### Toolbar Properties\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Toolbar/Toolbar.md
 ** module id = 1092
 ** module chunks = 0
 **/